<template>
    <div class="header">
        <div class="flex">
            <div class="logo"><img src="@/assets/logo.png"></div>
            <div class="menu">
                <div class="flex menu-center">
                    <div class="menu-item" @click="comp.setMenu(1)" :class="{'menu-selected':comp.menu==1}" v-if="comp.user.isAdmin=='Y'">
                        <div class="menu-icon"><i class="las la-scroll"></i><i class="las la-volume-up"></i></div>
                        <div class="menu-text">Script List</div>
                    </div>
                    <div class="menu-item" @click="comp.setMenu(2)" :class="{'menu-selected':comp.menu==2}" v-if="comp.user.isAdmin=='Y'">
                        <div class="menu-icon"><i class="las la-user-shield"></i><i class="las la-scroll"></i></div>
                        <div class="menu-text">Admin Script Manage</div>
                    </div>

                    <!-- file download script-nick -->
                    <div class="menu-item" @click="comp.setMenu(4)" :class="{'menu-selected':comp.menu==4}" v-if="comp.user.isAdmin=='Y'">
                        <div class="menu-icon"><i class="las la-save"></i></div>
                        <div class="menu-text">Download A</div>
                    </div>
                    <!-- file download nick-nick -->
                    <div class="menu-item" @click="comp.setMenu(5)" :class="{'menu-selected':comp.menu==5}" v-if="comp.user.isAdmin=='Y'">
                        <div class="menu-icon"><i class="las la-save"></i></div>
                        <div class="menu-text">Download B</div>
                    </div>

                    <div class="menu-item" @click="comp.setMenu(3)" :class="{'menu-selected':comp.menu==3}" v-if="comp.user.idx==20281">
                        <div class="menu-icon"><i class="las la-user-shield"></i><i class="las la-cog"></i></div>
                        <div class="menu-text">Tester Mgr</div>
                    </div>
                </div>
            </div>
            <div class="userinfo" v-if="comp.user.idx>0">
                {{ comp.user.ename }} <button class="btn-logout" @click="comp.logout()"><i class="las la-file-export la-lg"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
import { onMounted, reactive } from 'vue'
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

export default {
    props: {
        modelValue: {
            type: [Number, String],
            default: "00:00",
        },
    },
    emits: [ 'update:modelValue' ],
    setup(props, { emit }) {
        const store = useStore();
        const router = useRouter();
        const route  = useRoute();

        const comp = reactive({
            data : "",
            user : { idx:0, ename:'', isAdmn:'N' },
            menu : 1,
            logout: () => {
                store.commit("logout")
                store.commit("setMenu", 1)
                if( route.path.indexOf('Front') ){
                    window.location.href = '/Front/Login'
                } else {
                    window.location.href = 'https://www.carrotians.net/stage'
                }
            },
            setMenu: (num) => {
                comp.menu = num;
                switch(num){
                    default:
                    case 1:
                        router.push({"path":"/Front/List"});
                        break;
                    case 2:
                        router.push({"path":"/Admin/List"});
                        break;
                    case 3:
                        router.push({"path":"/Tester/List"});
                        break;
                    case 4:
                        window.open("/ai/voice_down_all?dtype=script", "filedownA")
                        break;
                    case 5:
                        window.open("/ai/voice_down_all?dtype=nick", "filedownB")
                        break;
                }
                store.commit("setMenu", num);
            },
            change: () => {
                emit('update:modelValue', comp.data);
            }
        });

        onMounted(() => {
            // Mounted
            store.dispatch('doReadStateFromStorage')
            comp.user = store.state.user
            comp.menu = store.state.menu

            setTimeout(() => {
                store.dispatch('doReadStateFromStorage')
                comp.user = store.state.user
                comp.menu = store.state.menu
            }, 400)
        });

        return {comp, store};
    }
}
</script>

<style lang="scss" scoped>
@import "src/scss/2022/color.scss";
.header {
    position: fixed;
    z-index: 900;
    width: 100%; height:50px;
    padding:5px 0;
    background-color: #FFF;
    border-bottom: 1px solid #ececec;
    .flex  {
        display: flex;
    }
    .logo {
        padding:0 10px;
        img {
            height: 40px;
        }
        text-align: center;
    }
    .menu {
        flex-grow: 1;
    }
    .userinfo {
        border-left: 1px solid #ccc;
    }
    .menu-center {
        margin: 0 auto;
    }
    .menu-item {
        line-height: 18px;
        text-align: center;
        border-radius: 5px;
        padding: 4px 10px;
        margin: 0 4px;
        background-color: #FFF;
        cursor: pointer;
        .menu-icon {
            color: #777;
            font-size: 18px;
        }
        .menu-text {
            color: #777;
            font-size: 11px;
            font-weight: 300;
            line-height: 11px;
        }
    }
    .menu-selected {
        box-shadow: 3px 3px 10px #ddd;
        border : 1px solid #ddd;
        .menu-icon {
            color: $primary-color;
        }
        .menu-text {
            font-weight: 500;
            color: $primary-color;
        }
    }
    .userinfo {
        text-align: center; height:40px; line-height:40px;  width:90px;
        .btn-logout {
            border: 0;
            font-size: 20px;
            background-color: #FFF;
        }
    }
    .pop-menu {
        height: 100px;
        display: none;
        position: absolute;
        top: 90px;
        width: 100%;
        .pop-menu-box {
            border-radius: 6px;
            padding: 5px;
            background-color: #FFF;
            border-radius: 1px solid #ececec;
            line-height: 160%;
            width: 500px;
            margin: 0 auto;
        }
    }
}
</style>